const OfferLineBreakdown = {
  paid_and_free: '{{paidQuantity}} × {{price}} paid · {{freeQuantity}} × free',
  all_free: '{{freeQuantity}} × free',
};

export default OfferLineBreakdown;
